import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		text: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => {
						return mobileAlignment ? `${mobileAlignment} !important` : null
					},
				},
			},
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: 2,
		},
		image: {
			display: 'flex',
			alignItems: 'center',
			height: theme.spacing(15.5),
			width: '100%',
			marginBottom: theme.spacing(2),
			'& img': {
				objectFit: 'contain',
				width: '100%',
				height: '100%',
			},
		},
	}),
	{ name: 'Category-Category1' },
)

export default useStyles
